module.exports = __webpack_public_path__ + "media/images/japan/tips_4-70fe774ca85dc985e740f3c56e674b49.jpg";